module.exports = __webpack_public_path__ + "static/surface-treatment-f2638560a9245e9b230ab464661e6b89.png";